import { render, staticRenderFns } from "./ListPageHeader.vue?vue&type=template&id=2d5cd140&scoped=true&"
import script from "./ListPageHeader.vue?vue&type=script&lang=js&"
export * from "./ListPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListPageHeader.vue?vue&type=style&index=0&id=2d5cd140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cd140",
  null
  
)

export default component.exports